module.exports = __webpack_public_path__ + "img/DSC_0038.03868214.jpg";